import { Box, styled, Theme } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  background: theme.palette.type === 'dark' ? COLORS.DARK_BACKGROUND : COLORS.LIGHT_BACKGROUND,
  border:
    theme.palette.type === 'dark' ? '1px solid' + COLORS.DARK_BORDER : '1px solid' + COLORS.LIGHT_BORDER + '!important',
  borderRadius: '10px',
  width: '100%',
  cursor: 'pointer',
  overflow: 'hidden',
}));

export const Header = styled('div')(({ theme }) => ({
  padding: 15,
  borderBottom:
    theme.palette.type === 'dark' ? '1px solid' + COLORS.DARK_BORDER : '1px solid' + COLORS.LIGHT_BORDER + '!important',
  display: 'flex',
  alignItems: 'center',
  gap: 15,

  '& * p': {
    lineHeight: 1.2,
  },

  '& > div:last-child': {
    marginLeft: 'auto',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  padding: 15,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  justifyContent: 'center',
  '& > div': {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
  },
}));

export const FlexRightContainer = styled('div')<Theme, { isSelftapes: boolean }>(({ theme, isSelftapes }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 5,
  justifyContent: 'flex-end',

  [theme.breakpoints.down(1000)]: {
    justifyContent: 'unset',
  },

  '& svg': {
    width: 20,

    '& path': {
      fill: isSelftapes ? '#BC30FF' : COLORS.PRIMARY,
    },
  },
}));

export const HeaderMiddleContainer = styled('div')(({ theme }) => ({
  '& > p': {
    maxWidth: 200,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}));

export const IconCont = styled(Box)<Theme, { BG: string }>(({ theme, BG }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '40px',
  minWidth: '40px',
  borderRadius: '5px',
  background: `${BG}`,
  '& svg': {
    '& path': {
      fill: 'white',
    },
  },
}));
